<template>
  <div class="flex flex-col items-center">
    <check-mark-icon />
    <h3 class="text-semibold text-root-2 text-2xl text-center mt-5">
      Deposit Confirmed
    </h3>
    <p style="word-break: normal" class="font-normal mt-2 w-3/4 text-center">
      We received
      <span class="font-bold text-root-2">
        {{
          parseMoneyAll(
            transferDetails.debitAmount.toFixed(2),
            country.currency
          )
        }}</span
      >
    </p>
    <p class="text-xs my-1 font-medium">
      Initiating Transfer in {{ seconds }} seconds
    </p>
    <o-button @click="next" class="w-3/4 mt-5">Continue</o-button>
  </div>
</template>

<script>
import { ParseMoneyAll } from '@/utils/helpers'
import country from '@/mixins/getCountryDetails.js'
export default {
  mixins: [country],
  components: {
    CheckMarkIcon: () => import('@/assets/icons/CheckMarkIcon.vue')
  },
  computed: {
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    }
  },
  data () {
    return {
      seconds: 3,
      timerInterval: ''
    }
  },
  methods: {
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    next () {
      // const details = {
      //   transferReason: transferReason,
      //   debitAmount: FormatAmount(this.enteredAmountForm.enteredAmount),
      //   fees: this.fees,
      //   recipientAmount: this.fromBalance
      //     ? this.recipientAmountBalance
      //     : AddComma(
      //       parseFloat(FormatAmount(this.enteredAmountForm.recipientAmount))
      //         .toFixed(2)
      //         .toString()
      //     ),
      //   partnerCommission: !this.transferSourceIsGlobalFiat
      //     ? this.partnerCommission
      //     : 0
      // }
      // this.$store.dispatch('terminal/setTransferDetails', details)
      this.$emit('continue')
    },
    countDown () {
      this.timerInterval = setInterval(() => {
        this.seconds--
        if (this.seconds < 1) {
          this.next()
          clearInterval(this.timerInterval)
        }
      }, 1000)
    }
  },
  mounted () {
    this.countDown()
  },
  beforeDestroy () {
    clearInterval(this.timerInterval)
  }
}
</script>

<style></style>
